(() => {
  let elem;
  const attributes = {
    // eslint-disable-next-line
    'role': 'button',
    'aria-controls': 'swinger-overlay-confirmation-dialog',
    'aria-expanded': 'false',
    'aria-haspopup': 'dialog',
  };
  let widget;
  let overlay;
  let promise;
  let resolver;
  let rejecter;

  const mark = (elem) => {
    if (!elem) {
      return;
    }

    window.swinger.$('[aria-controls="swinger-overlay-confirmation-dialog"]').forEach((elem) => { elem.removeAttribute('data-invoker'); });
    elem.setAttribute('data-invoker', 'swinger-overlay-confirmation-dialog');

    if (elem.hasAttribute('data-previous-set')) {
      return;
    }
    elem.setAttribute('data-previous-set', '');
    Object.keys(attributes).forEach((key) => {
      const previousValue = elem.getAttribute(key);
      if (previousValue) {
        elem.setAttribute(`data-previous-${key}`, previousValue);
      }
      const value = attributes[key];
      elem.setAttribute(key, value);
    });
  };

  const unmark = (elem) => {
    Object.keys(attributes).forEach((key) => {
      const previousValue = elem.getAttribute(`data-previous-${key}`);
      elem[previousValue ? 'setAttribute' : 'removeAttribute'](key, previousValue);
      elem.removeAttribute(`data-previous-${key}`);
    });
    elem.removeAttribute('data-previous-set');
  };

  const openOverlay = (initialState) => {
    mark(elem);

    widget = window.swinger.widgets[widget ? 'replace' : 'create']({
      type: 'confirmation-dialog',
      initialState,
    }, widget);

    (
      document.getElementById('swinger-append-container')
      || window.swinger.$('body', document)[0]
    ).appendChild(widget);
  };

  const cleanup = () => {
    const elem = document.querySelector('[aria-controls="swinger-overlay-confirmation-dialog"][data-invoker]');
    if (elem) {
      window.setTimeout(() => {
        unmark(elem);
      }, 100);
    }
  };

  window.swinger.eventHub.register('submit', '.swinger-confirmation', (e) => {
    const button = e.submitter;
    const response = button.value;

    cleanup();

    if (resolver) {
      resolver(response);
      resolver = undefined;
      rejecter = undefined;
    }

    window.swinger.overlayManager.close(overlay);
    e.preventDefault();
  });

  window.swinger.eventHub.register('click', window.swinger.focusableElements.join(','), (e) => {
    const target = window.swinger.eventHub.getTarget(e).closest(window.swinger.focusableElements.join(','));
    if (overlay && overlay.contains(target)) {
      return;
    }
    elem = target;
  });

  document.addEventListener('swinger.overlay:close', (e) => {
    if (overlay !== e.detail.elem) {
      return;
    }

    cleanup();

    if (rejecter) {
      rejecter(false);
      resolver = undefined;
      rejecter = undefined;
    }
  });

  window.swinger.observer.initialize('#swinger-overlay-confirmation-dialog', (elem) => {
    overlay = elem;
  }, false);

  window.swinger = window.swinger || {};
  window.swinger.confirm = (options) => {
    promise = new Promise((resolve, reject) => {
      resolver = resolve;
      rejecter = reject;
    });
    openOverlay(options);
    return promise;
  };
})();
